import { __read, __spread } from "tslib";
import { dateTime, FieldType } from '@grafana/data';
import throttle from 'lodash/throttle';
var LOGGING_ENABLED = false;
var ALLOWED_FORMAT_STRINGS_REGEX = /\b(YYYY|YY|MMMM|MMM|MM|M|DD|D|WWWW|WWW|HH|H|h|AA|aa|a|mm|m|ss|s|fff)\b/g;
export function timeFormatToTemplate(f) {
    return f.replace(ALLOWED_FORMAT_STRINGS_REGEX, function (match) { return "{" + match + "}"; });
}
export function buildPlotConfig(props, plugins) {
    return {
        width: props.width,
        height: props.height,
        focus: {
            alpha: 1,
        },
        cursor: {
            focus: {
                prox: 30,
            },
        },
        legend: {
            show: false,
        },
        plugins: Object.entries(plugins).map(function (p) { return ({
            hooks: p[1].hooks,
        }); }),
        hooks: {},
    };
}
/** @internal */
export function preparePlotData(frame, ignoreFieldTypes) {
    var result = [];
    for (var i = 0; i < frame.fields.length; i++) {
        var f = frame.fields[i];
        if (f.type === FieldType.time) {
            if (f.values.length > 0 && typeof f.values.get(0) === 'string') {
                var timestamps = [];
                for (var i_1 = 0; i_1 < f.values.length; i_1++) {
                    timestamps.push(dateTime(f.values.get(i_1)).valueOf());
                }
                result.push(timestamps);
                continue;
            }
            result.push(f.values.toArray());
            continue;
        }
        if (ignoreFieldTypes && ignoreFieldTypes.indexOf(f.type) > -1) {
            continue;
        }
        result.push(f.values.toArray());
    }
    return result;
}
// Dev helpers
/** @internal */
export var throttledLog = throttle(function () {
    var t = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        t[_i] = arguments[_i];
    }
    console.log.apply(console, __spread(t));
}, 500);
/** @internal */
export function pluginLog(id, throttle) {
    if (throttle === void 0) { throttle = false; }
    var t = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        t[_i - 2] = arguments[_i];
    }
    if (process.env.NODE_ENV === 'production' || !LOGGING_ENABLED) {
        return;
    }
    var fn = throttle ? throttledLog : console.log;
    fn.apply(void 0, __spread(["[Plugin: " + id + "]: "], t));
}
//# sourceMappingURL=utils.js.map